import { render } from "./TableFooter.vue?vue&type=template&id=d2525720&scoped=true&ts=true"
import script from "./TableFooter.vue?vue&type=script&lang=ts"
export * from "./TableFooter.vue?vue&type=script&lang=ts"

import "./table-footer.scss?vue&type=style&index=0&id=d2525720&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2525720"]])

export default __exports__